import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Notice, WarningNotice, InfoNotice, SuccessNotice, ErrorNotice } from './notice/notice';
import { ProgressBarService } from '@app/shared/services/progress-bar.service';

@Injectable()
export class InfoService {

    public wait = false;
    public waitMessage: string;

    private _debug = true;

    // Observable string sources
    private _notice = new Subject<Notice>();
    private _endWait = new Subject<boolean>();

    // Observable string streams
    public notice$ = this._notice.asObservable();
    public endWait$ = this._endWait.asObservable();

    constructor(
        private proggresBarService: ProgressBarService
    ) {
    }

    hideNotice(): void {
        this._notice.next(new Notice(''));
    }

    sendNotice(notice: Notice, timeout?: number): void {
        this.hideNotice();
        this.endWait(true);
        this._notice.next(notice);
    }

    error(msg?: string, timeout?: number): void {
        this.sendNotice(new ErrorNotice(msg), timeout);
    }

    success(msg?: string, timeout?: number): void {
        this.sendNotice(new SuccessNotice(msg), timeout);
    }

    warning(msg: string, timeout?: number): void {
        this.sendNotice(new WarningNotice(msg), timeout);
    }

    notice(msg: string, timeout?: number): void {
        this.sendNotice(new InfoNotice(msg), timeout);
    }

    dismissAll(): void {
        this.endWait();
    }

    startWait(message: string): void {
        this.waitMessage = message;
        this.notice(message, 1000000);
        this.wait = true;
    }

    endWait(skipClosingNotices?: boolean): void {
        this.proggresBarService.setNull();
        this.waitMessage = '';
        this.wait = false;
        if (!skipClosingNotices) {
            this._endWait.next(true);
        }
    }

    log(v: any): void {
        if (this._debug) {
            console.log(v);
        }
    }

    get debug(): boolean {
        return this._debug;
    }
}
